var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUilYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2823 9.70998C23.3317 8.27864 23.0187 6.858 22.3723 5.57998C21.9337 5.05558 21.325 4.70169 20.6523 4.57998C17.8698 4.32751 15.0758 4.22403 12.2823 4.26998C9.4989 4.22194 6.71496 4.32208 3.94225 4.56998C3.39407 4.6697 2.88677 4.92683 2.48225 5.30998C1.58225 6.13998 1.48225 7.55998 1.38225 8.75998C1.23717 10.9175 1.23717 13.0824 1.38225 15.24C1.41118 15.9154 1.51175 16.5858 1.68225 17.24C1.80283 17.745 2.04678 18.2123 2.39225 18.6C2.79952 19.0034 3.31864 19.2752 3.88225 19.38C6.03817 19.6461 8.21047 19.7564 10.3823 19.71C13.8823 19.76 16.9523 19.71 20.5823 19.43C21.1597 19.3316 21.6934 19.0595 22.1123 18.65C22.3922 18.3699 22.6013 18.0271 22.7223 17.65C23.0799 16.5526 23.2555 15.4041 23.2423 14.25C23.2823 13.69 23.2823 10.31 23.2823 9.70998ZM10.0223 14.85V8.65998L15.9423 11.77C14.2823 12.69 12.0923 13.73 10.0223 14.85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUilYoutube);
export default __webpack_public_path__ + "static/media/uil_youtube.44e53abadfecc6424f2252ba8baafbdd.svg";
export { ForwardRef as ReactComponent };